import { EmailArtifactLocation } from '@amazon-connect/email';
import { emailApiClient } from './emailApiClient';

export const fetchEmailBody = async (
  bodyLocation: EmailArtifactLocation,
  contactId: string
): Promise<string | undefined> => {
  const params = new URLSearchParams({ fileId: bodyLocation.fileId, contactId });
  const response = await emailApiClient(`/body-legacy?${params.toString()}`, {
    method: 'GET'
  });

  if (!response.ok) throw new Error(`API responded with status ${response.status}`);

  const json = (await response.json()) as {
    meta: { version: string };
    data: { body: string; ccAddresses: string[] };
  };

  return json.data.body;
};
